











































































































































































































import { defineComponent, ref, reactive, computed } from '@vue/composition-api';
import AsyncSelect from '@/components/AsyncSelect';
import request from '@/utils/request';

export default defineComponent({
  name: 'Form',
  components: {
    AsyncSelect,
  },
  props: {
    formColumn: {
      type: Array,
      defalut: [],
    },
    propsForm: {
      type: Object,
      defalut: {},
    },
    url: {
      type: String,
      defalut: '',
    },
    customFunc: {
      type: Function,
      defalut: () => {},
    },
    formSize: {
      type: String,
      defalut: 'small',
    },
  },
  setup(props: any, { emit }) {
    const form = reactive(props.propsForm);
    const downloadUrl = ref(props.url);
    const size = computed(() => {
      const rs = 3 - (props.formColumn.length % 3);
      return rs === 0 ? 8 : rs * 8;
    });

    const search = () => {
      emit('onSearch', form);
    };
    const remoteMethod = (query) => {
      emit('getSupplierInfoSelect', query);
    };
    const download = () => {
      const [fileName, url] = downloadUrl.value.split('-');
      request(fileName, url, form);
    };

    const onChange = (val) => {
      const [value, name] = val;
      form[name] = value;
    };

    const data = {
      form,
      search,
      download,
      downloadUrl,
      size,
    };

    return {
      form,
      size,
      downloadUrl,
      download,
      search,
      onChange,
      data,
      remoteMethod,
    };
  },
});
